import { BCMSDate } from "@bcm-dev/bcms-vite";
import { useRef, useState } from "react";
import { SVGAsset } from "res";
import MobilePickerTopHeader from "../MobilePickerHeader";
import Month from "../Month";

export default function MobileDoubleCalendar(props) {
    const [viewDate, setViewDate] = useState(BCMSDate.init(props.setDate).date);

    const ref = useRef();

    let month1 = BCMSDate.init(viewDate);
    let month2 = BCMSDate.init(viewDate).offset([0, 1, 0])
    const  close = props.controllers.close;
    return (
        <div className="date-picker flex-container flex-width flex-vertical">
            <div className="close-icon-container flex-container flex-horizontal align-center justify-right link clickable" onClick={close}><SVGAsset id="CloseIcon" className="icon" /></div>
            <div className="month-container">
                <div className="row">
                    <MobilePickerTopHeader month1={month1} setViewDate={setViewDate} disabled={props.disabled} />
                </div>
                <div className='calendar-wrapper'>
                    <Month viewDate={month1} setDate={props.setDate} onChange={props.onChange} controllers={props.controllers} />
                    <div className="divider" />
                    <MobilePickerTopHeader month1={month2} setViewDate={setViewDate} isFixed={true}/>
                    <Month viewDate={month2} onChange={props.onChange} setDate={props.setDate} controllers={props.controllers} />
                </div>
            </div>
            
        </div>
    )
} 